import { render } from "./WCDesktopHeaderV2.vue?vue&type=template&id=5db56840&scoped=true"
import script from "./WCDesktopHeaderV2.vue?vue&type=script&lang=js"
export * from "./WCDesktopHeaderV2.vue?vue&type=script&lang=js"

import "./WCDesktopHeaderV2.vue?vue&type=style&index=0&id=5db56840&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db56840"]])

export default __exports__